import { CommonUtilities } from '../../commonUtils';

export default class PaymentServices {
    static getClientDetails() {
        var url = 'client/getClientDetails'
        return CommonUtilities.getData(url);
    }

    static async tagColor() {
        var url = 'common/tagColor/listAll';
        return await CommonUtilities.getData(url);
    }

    static async initCheck() {
        var url = 'provider/tipalti/initCheck';
        return await CommonUtilities.getData(url);
    }

    static authInitialisation(param: any) {
        var url = 'provider/tipalti/authInitialisation';
        return CommonUtilities.postData(url, param);
    }

    static authoriseTipalti = function (postData: any) {
        var url = 'provider/tipalti/authorisation';
        return CommonUtilities.postData(url, postData);
    };

    static tipaltiInitCheck = function (postData: any) {
        var url = 'provider/tipalti/callback' + postData;
        return CommonUtilities.getData(url);
    };

    static async paymentVendor(clientName: any) {
        var url = 'contract/paymentVendor/list?' + CommonUtilities.buildQueryString(clientName, true, true);
        return await CommonUtilities.getData(url);
    }

    static ViewUploadFileLog(Data: {}) {
        var url = 'importLog/SearchFileLog/SPY/none?' + Data;
        return CommonUtilities.getData(url);
    }

    static updatedAPayment(param: any) {
        var url = 'contracts/getUpdatedAPayment/20251231?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static periodCountList() {
        var url = 'common/periodCount'
        return CommonUtilities.getData(url);
    }

    static suggestedPaymentsCount() {
        var url = 'contracts/suggestedPayments/count'
        return CommonUtilities.getData(url);
    }

    static suggestedPaymentclear() {
        var url = 'contracts/suggestedPayments/clear'
        return CommonUtilities.getData(url);
    }

    static suggestedPaymentSelectList(param: any) {
        var url = 'contracts/suggestedPayments/selectList?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static savePayment(Period: any, param: any, contract: any) {
        var url = 'contracts/savePayment/' + Period + '?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.postData(url, contract);
    }

    static ReCalcOpeningBalance(param: any) {
        var url = 'contracts/ReCalcOpeningBalance';
        return CommonUtilities.postData(url, param);
    }

    static suggestedPaymentFileUpload(file: any) {
        var url = 'suggestedPayments/fileUpload'
        return CommonUtilities.postUploadFile(url, file, {});
    }

    static suggestedPaymentExport(param: any) {
        var url = 'contracts/getPaymentDetails/export?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, param.exportType, param.type);
    }

    static suggestedPaymentDelete(data: any) {
        var url = 'contracts/suggestedPayments/' + data;
        return CommonUtilities.deleteData(url);
    }

    static saveStatusFlag(param: any) {
        var url = 'contracts/saveStatusFlag/' + param;
        return CommonUtilities.postData(url, {});
    }

    static savePaymentKontactInfo(param: any) {
        var url = 'contracts/savePaymentKontactInfo?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.postData(url, {});
    }
}